import React, { Component, lazy, Suspense } from "react"
import { Route, Switch } from "react-router-dom"
import { connect } from "react-redux"

//Components
import Footer from "./components/Footer/Footer"
import Toolbar from "./components/Toolbar/Toolbar"
import Spinner from "./components/Spinner/Spinner"
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary"

//External Libraries
import AOS from "aos"

// Styling
import "./assets/scss/main.scss"
import "./assets/aos.css" //don'tforget to remove this import. We are using the CDN import in our html file

//Containers
const Home = lazy(() => import("./containers/Home/Home"))
const Projects = lazy(() => import("./containers/Projects/Projects"))
const Contact = lazy(() => import("./containers/Contact/Contact"))
const About = lazy(() => import("./containers/About/About"))
const Project = lazy(() => import("./components/ProjectsSub/Project/Project"))
const showLoader = () => (
	<main className='main main--lazy'>
		<Spinner />
	</main>
)

class App extends Component {
	render() {
		AOS.init({
			duration: 1000
		})

		return (
			<ErrorBoundary>
				<Toolbar />
				<Suspense fallback={showLoader()}>
					<Switch>
						<Route path='/' exact component={Home} />
						<Route path='/projects' component={Projects} />
						<Route path='/contact' component={Contact} />
						<Route path='/about' component={About} />
						<Route
							path={"/" + this.props.currentProjectLink}
							component={Project}
						/>
						<Route
							path={
								"/" +
								window.location.href.split("/")[
									window.location.href.split("/").length - 1
								]
							}
							component={Project}
						/>
					</Switch>
				</Suspense>
				<Footer />
			</ErrorBoundary>
		)
	}
}

const mapStateToProps = state => {
	let link = "404"

	if (state.projects.currentProject) {
		link = state.projects.currentProject.link
	}

	return {
		currentProjectLink: link
	}
}

export default connect(mapStateToProps)(App)
